export const CONTENT_TYPE = {
	JSON: 'application/json',
	TEXT: 'text/plain',
	HTML: 'text/html',
}
